import { useMutation } from "@apollo/client";
import { Button } from "@clockwise/design-system";
import { SaveUserSurveyResponseWrapperMutationInput } from "@clockwise/schema";
import React, { useState } from "react";
import { useWebOnboardingSteps } from "../../hooks/useWebOnboardingSteps";
import { ButtonGroup, StepCounter, StepLayout } from "../../shared-components";
import { setError } from "../../utils/setError";
import { GetToKnowYouSlide } from "./GetToKnowYouSlide";
import { getDefaultInput } from "./GetToKnowYouStep.util";
import { OnboardingSaveUserSurveyResponseMutationDocument } from "./__generated__/OnboardingSaveUserSurveyResponse.generated";

export const GetToKnowYouStep = ({
  orgId,
  canSkipOnboarding,
}: {
  orgId: string;
  canSkipOnboarding: boolean;
}) => {
  const [saveSurveyResponses] = useMutation(OnboardingSaveUserSurveyResponseMutationDocument);
  const [disableButtons, setDisableButtons] = useState(false);

  const {
    goForward,
    goBack,
    shouldShowSecondaryButton,

    skipOnboarding,
  } = useWebOnboardingSteps();

  const [
    userSurveyInput,
    setUserSurveyInput,
  ] = useState<SaveUserSurveyResponseWrapperMutationInput>(getDefaultInput(orgId));

  const onChangeResponse = (
    input: SaveUserSurveyResponseWrapperMutationInput,
    isButtonDisabled: boolean,
  ) => {
    setUserSurveyInput(input);
    setDisableButtons(isButtonDisabled);
  };

  const saveAndGoForward = () => {
    setDisableButtons(true);
    saveSurveyResponses({
      variables: { input: userSurveyInput },
      onCompleted: () => {
        setDisableButtons(false);
        goForward();
      },
      onError: (error) => {
        setDisableButtons(false);
        setError({
          message: "failed to save user survey results",
          error: error,
          showUserMessage: true,
        });
      },
    });
  };

  const SkipButton = () => {
    return (
      <div className="cw-mt-8">
        <Button
          variant="outlined"
          sentiment="neutral"
          onClick={() => skipOnboarding()}
          cw-id="skip-web-onboarding"
        >
          Skip onboarding
        </Button>
      </div>
    );
  };

  return (
    <StepLayout>
      <StepCounter />
      <GetToKnowYouSlide orgId={orgId} onChange={onChangeResponse} />
      <ButtonGroup
        shouldShowSecondary={shouldShowSecondaryButton}
        primaryLabel={"Next"}
        secondaryLabel={"Back"}
        onClickPrimary={saveAndGoForward}
        onClickSecondary={goBack}
        disabled={disableButtons}
      />
      {canSkipOnboarding && <SkipButton />}
    </StepLayout>
  );
};
